import{ThemeType as r}from"../types.js";var t=r.light;export{t as DEFAULT_THEME_TYPE};
